import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Checkbox from "./Checkbox";

import { toggleInArray } from "../../utils/array";
import { getOptionKey } from "../../utils/select";

import styles from "./CheckboxGroup.module.scss";

const CheckboxGroup = ({
  className,
  isTranslateLabels,
  colClassName,
  options,
  value,
  onChange,
  isInline,
  disabled,
  ariaLabelledBy,
}) => {
  return (
    <div
      aria-labelledby={ariaLabelledBy}
      role="group"
      className={classNames(
        "CheckboxGroup",
        styles["CheckboxGroup"],
        styles[colClassName],
        className,
      )}
    >
      {(options || []).map((item) => {
        const key = getOptionKey(item);
        return (
          <Checkbox
            key={key}
            isTranslateLabel={isTranslateLabels}
            title={item.label}
            isInline={isInline}
            disabled={disabled?.includes(key)}
            checked={value.includes(key)}
            onChange={() => {
              const valueNew = [...value];
              toggleInArray(valueNew, key);
              onChange(valueNew, key);
            }}
          />
        );
      })}
    </div>
  );
};

CheckboxGroup.propTypes = {
  options: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
  className: PropTypes.string,
  colClassName: PropTypes.string,
};

export default CheckboxGroup;
